var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-card-title',{staticClass:"text_box"},_vm._l((_vm.getProjectSkills),function(skill){return _c('div',{key:skill.id},[_c('v-chip',{attrs:{"color":"info","close":""},on:{"click:close":function($event){return _vm.deleteSkill(skill)}}},[_vm._v(" "+_vm._s(skill.skill_name)+" ")])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }